(() => {
  if (customElements.get('dd-filter-carousel')) return;
  const params = {colour:'filter.v.m.custom.filter_colour',material:'filter.v.m.custom.filter_material',silhouette:'filter.p.m.custom.filter_silhouette'};
  class DDFilterCarousel extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.state = {};
      this.navigateResults = this.dataset.ddResultsNavigation === 'true' && location.pathname.includes('/collections/');
      if(this.navigateResults){const query=new URLSearchParams(location.search);for(const [group,param]of Object.entries(params))this.state[group]=query.get(param)||'';}
      this.committed = {...this.state};
      this.sequence = 0;
      this.rail = this.querySelector('[data-dd-rail]');
      if (!this.rail || !this.dataset.ddSource) return;
      this.status = this.querySelector('[data-dd-status]');
      this.empty = this.querySelector('[data-dd-no-results]');
      this.browse = this.querySelector('[data-dd-browse]');
      this.querySelectorAll('[data-dd-controls]').forEach(el => el.hidden = false);
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-dd-filter]');
        if (option && this.contains(option)) {
          const group = option.dataset.ddFilter;
          this.state[group] = this.state[group] === option.dataset.ddValue ? '' : option.dataset.ddValue;
          this.paint(); this.load();
        }
        if (event.target.closest('[data-dd-reset]')) { this.state = {}; this.paint(); this.load(); }
        const direction = event.target.closest('[data-dd-direction]');
        if (direction) this.move(Number(direction.dataset.ddDirection));
      }, {signal:this.events.signal});
      this.rail.addEventListener('scroll', () => this.navigation(), {passive:true,signal:this.events.signal});
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.rail.scrollTo({left:event.key === 'Home' ? 0 : this.rail.scrollWidth,behavior:'auto'}); }
      }, {signal:this.events.signal});
      this.observer = new ResizeObserver(() => this.navigation()); this.observer.observe(this.rail);
      this.navigation();
      this.initialiseOptions();
      if (!this.navigateResults && [...new URLSearchParams(location.search).keys()].some(key => key.startsWith('filter.'))) this.load();
    }
    async initialiseOptions() {
      try {
        const url = new URL(this.dataset.ddSource,location.origin); url.searchParams.set('section_id','dd-filter-options');
        const response = await fetch(url,{signal:this.events.signal,credentials:'same-origin'});
        if (!response.ok) throw Error('Unable to load filters');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        for (const group of this.querySelectorAll('[data-dd-group]')) {
          if (!group.matches('fieldset')) continue;
          const options = doc.querySelector(`[data-dd-option-group="${group.dataset.ddGroup}"]`);
          if (!options) throw Error('Filter source not configured');
          group.querySelector('.dd-fc__options').replaceChildren(...options.children);
        }
        this.querySelectorAll('[data-dd-override]').forEach(override => {
          const value = override.dataset;
          const option = [...this.querySelectorAll('[data-dd-filter]')].find(el => el.dataset.ddFilter === value.ddGroup && el.dataset.ddValue === value.ddValue);
          if (!option) return;
          if (value.ddLabel) option.querySelector('span:not([aria-hidden])').textContent = value.ddLabel;
          const swatch = option.querySelector('.dd-fc__swatch');
          if (swatch && value.ddColour) swatch.style.setProperty('--dd-swatch',value.ddColour);
          const media = value.ddIcon || value.ddTexture;
          const target = value.ddIcon ? option.querySelector('.dd-fc__icon') : swatch;
          if (media && target) { const img = document.createElement('img'); img.src = media; img.width = 24; img.height = 24; img.alt = ''; img.loading = 'lazy'; target.replaceChildren(img); }
        });
        this.paint();
      } catch(error) { if (error.name !== 'AbortError' && this.isConnected) this.status.textContent = this.dataset.ddError; }
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); this.observer?.disconnect(); this.events = null; }
    paint() {
      this.querySelectorAll('[data-dd-filter]').forEach(button => button.setAttribute('aria-pressed',String(this.state[button.dataset.ddFilter] === button.dataset.ddValue)));
    }
    url() {
      const url = new URL(this.dataset.ddSource,location.origin);
      for (const [group,param] of Object.entries(params)) if (this.state[group]) url.searchParams.set(param,this.state[group]);
      url.searchParams.set('filter.v.availability','1');
      return url;
    }
    move(direction) {
      this.rail.scrollBy({left:direction*this.rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    navigation() {
      const end = this.rail.scrollWidth-this.rail.clientWidth;
      const prev = this.querySelector('[data-dd-direction="-1"]'), next = this.querySelector('[data-dd-direction="1"]');
      if (prev) prev.disabled = this.rail.scrollLeft <= 2;
      if (next) next.disabled = this.rail.scrollLeft >= end-2;
    }
    async page(url,signal) {
      url = new URL(url,location.origin);
      if (url.origin !== location.origin) throw Error('Unexpected result origin');
      url.searchParams.set('section_id','dd-filter-results');
      const response = await fetch(url,{signal,credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}});
      if (!response.ok) throw Error('Unable to load products');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const result = doc.querySelector('[data-dd-result-page]');
      if (!result || /Liquid error/i.test(result.textContent)) throw Error('Invalid section response');
      return result;
    }
    namespace(card,index) {
      const mediaId = card.dataset.ddImageId;
      const gallery = card.querySelector('.card-gallery');
      const slides = gallery?.querySelector('slideshow-slides');
      const matching = slides && [...slides.children].find(slide => slide.getAttribute('slide-id') === mediaId);
      if (matching && slides.firstElementChild !== matching) {
        slides.prepend(matching);
        [...slides.children].forEach((slide,i) => {
          slide.setAttribute('aria-hidden',String(i !== 0));
          slide.style.setProperty('--slideshow-timeline',`--slide-${i}`);
          if (slide.hasAttribute('variant-image')) slide.hidden = slide !== matching;
        });
        matching.hidden = false;
        gallery.querySelector('slideshow-component')?.setAttribute('initial-slide','0');
      }
      const prefix = `${this.id}-${this.sequence}-${index}-`, ids = new Map();
      card.querySelectorAll('[id]').forEach(el => { ids.set(el.id,prefix+el.id); el.id = prefix+el.id; });
      card.querySelectorAll('*').forEach(el => {
        for (const attr of ['for','aria-controls','aria-labelledby','aria-describedby']) if(el.hasAttribute(attr)) el.setAttribute(attr,el.getAttribute(attr).split(' ').map(id => ids.get(id)||id).join(' '));
        const href = el.getAttribute('href'); if(href?.startsWith('#') && ids.has(href.slice(1))) el.setAttribute('href','#'+ids.get(href.slice(1)));
      });
      return card;
    }
    resultsUrl(){
      const url=new URL(location.href);
      for(const [group,param]of Object.entries(params)){url.searchParams.delete(param);if(this.state[group])url.searchParams.set(param,this.state[group]);}
      for(const key of [...url.searchParams.keys()])if(key==='page'||key.startsWith('page_'))url.searchParams.delete(key);
      return url;
    }
    async load() {
      if(this.navigateResults){location.assign(this.resultsUrl());return;}
      this.request?.abort(); const sequence = ++this.sequence;
      this.request = new AbortController(); const signal = this.request.signal;
      const state = {...this.state}, browse = this.url();
      this.setAttribute('aria-busy','true'); this.status.textContent = this.dataset.ddLoading;
      this.rail.hidden = true; this.empty.hidden = true;
      try {
        const cards = [], seen = new Set(), visited = new Set(), limit = Number(this.dataset.ddLimit);
        let next = browse;
        while (next && cards.length < limit) {
          const key = String(next); if (visited.has(key)) throw Error('Repeated result page'); visited.add(key);
          const result = await this.page(next,signal);
          for (let card of result.querySelectorAll('[data-dd-result-card]')) {
            if (seen.has(card.dataset.ddProduct)) continue;
            if (card.dataset.ddVariant !== card.dataset.ddNativeVariant) {
              const exact = await this.page(card.dataset.ddProductUrl,signal);
              const replacement = exact.querySelector('[data-dd-result-card]');
              if (!replacement || replacement.dataset.ddVariant !== card.dataset.ddVariant) throw Error('Variant mismatch');
              card = replacement;
            }
            seen.add(card.dataset.ddProduct); cards.push(this.namespace(card,cards.length));
            if (cards.length === limit) break;
          }
          next = result.dataset.ddNext || null;
        }
        if (sequence !== this.sequence || signal.aborted || !this.isConnected) return;
        this.rail.replaceChildren(...cards); this.rail.scrollLeft = 0;
        this.rail.hidden = cards.length === 0; this.empty.hidden = cards.length !== 0;
        this.browse.href = browse; this.committed = state;
        this.status.textContent = cards.length ? this.dataset.ddCount.replace('[count]',String(cards.length)) : this.dataset.ddEmpty;
        this.navigation();
      } catch(error) {
        if (error.name === 'AbortError' || sequence !== this.sequence || !this.isConnected) return;
        this.state = {...this.committed}; this.paint();
        this.rail.hidden = this.rail.children.length === 0; this.empty.hidden = this.rail.children.length !== 0;
        this.status.textContent = this.dataset.ddError;
      } finally { if (sequence === this.sequence) this.removeAttribute('aria-busy'); }
    }
  }
  customElements.define('dd-filter-carousel', DDFilterCarousel);
})();
